<template>
  <SAuthLayout>
    <v-col cols="12" md="3" v-if="!isMobile" class="ma-0 pa-0">
      <SAuthSide>
        <div class="d-flex flex-column ma-5">
          <div class="text-h4 font-weight-bold font-italic white--text mb-5">
            Bienvenue !
          </div>
        </div>
      </SAuthSide>
    </v-col>
    <v-col cols="12" md="9" class="ma-0 pa-0">
      <FinishRegisterForm />
    </v-col>
  </SAuthLayout>
</template>

<script>
import SAuthLayout from "@/views/authentification/SAuthLayout";
import FinishRegisterForm from "@/components/authentification/FinishRegisterForm";

export default {
  name: "FinishRegister",
  data: () => ({}),
  components: {
    SAuthLayout,
    FinishRegisterForm,
  },
  computed: {
    isMobile() {
      return window.innerWidth < 600;
    },
  },
};
</script>

<style scoped></style>
